import makeStyles from '@mui/styles/makeStyles';

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});

const styles = makeStyles(() => ({
  inventorySection: {
    display: "grid !important",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "20px",
    "@media (min-width: 1800px)": {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
    },
    "@media (max-width: 1310px)": {
      gridTemplateColumns: "1fr 1fr",
    },
    "@media (max-width: 767px)": {
      gridTemplateColumns: "1fr",
    },
  },

  subTitle: {
    ...getTextProperties("16px"),
    lineHeight: "24px",
    margin: "32px 0px 24px 0px",
  },

  empty: {
    ...getTextProperties("16px"),
    fontWeight: 500,
  },

  inventoryBox: {
    backgroundColor: "#F8F9FC",
    padding: "16px",
    borderRadius: "8px",
  },
  inventoryTop: {
    marginBottom: "16px",
  },
  inventoryBottom: {},
  inventoryTitle: {
    ...getTextProperties("16px"),
    marginBottom: "2px",
  },
  inventorySubTitle: {
    ...getTextProperties("14px"),
    color: "#98A2B3",
    flexWrap: "nowrap",
  },
  inventoryProperty: {
    ...getTextProperties("14px"),
    color: "#475467",
  },
  inventoryValue: {
    ...getTextProperties("14px"),
    color: "#667085",
  },
}));

export default styles;
